export default __webpack_public_path__ + "static/arley-1fc1590b5670fe02cf358c76fba72470.png";